<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useAccountStore } from '../stores/account'
import { useCustomerStore } from '../stores/customer'
import { useSuppliersStore } from '../stores/suppliers'
import { useCurrentOrganizationStore } from '../stores/currentOrganization'
import { storeToRefs } from 'pinia'
import CashFlowChart from '../components/cash-flow/CashFlowChart.vue'
import TransactionList from '../components/cash-flow/TransactionList.vue'
import CashFlowDashboard from '../components/cash-flow/CashFlowDashboard.vue'

const accountStore = useAccountStore()
const customerStore = useCustomerStore()
const supplierStore = useSuppliersStore()
const currentOrganizationStore = useCurrentOrganizationStore()

const { accounts, loading: accountsLoading } = storeToRefs(accountStore)
const { customers, loading: customersLoading } = storeToRefs(customerStore)
const { suppliers, loading: suppliersLoading } = storeToRefs(supplierStore)
const { organizationId } = storeToRefs(currentOrganizationStore)

const loading = computed(() => accountsLoading.value || customersLoading.value || suppliersLoading.value)
const activeTab = ref('current')
const filters = ref({
  dateRange: null,
  type: null,
  status: null
})

// Load all required data
onMounted(async () => {
  try {
    if (!organizationId.value) {
      console.error('No organization ID found')
      return
    }

    await Promise.all([
      accountStore.fetchAccounts(organizationId.value),
      customerStore.fetchCustomers(organizationId.value),
      supplierStore.getSuppliers()
    ])
  } catch (error) {
    console.error('Error loading cash flow data:', error)
  }
})
</script>

<template>
  <div class="p-6">
    <div class="mb-8">
      <h1 class="text-2xl font-bold mb-2">Fluxo de Caixa</h1>
      <p class="text-gray-600">Acompanhe seus lançamentos e previsões financeiras</p>
    </div>

    <div class="grid grid-cols-1 gap-4 sm:gap-6">
      <CashFlowDashboard :accounts="accounts" :loading="loading" />

      <TransactionList
        :accounts="accounts"
        :type="activeTab"
        :loading="loading"
        :customers="customerStore.customers"
        :suppliers="supplierStore.suppliers"
      />

      <div class="bg-white rounded-lg shadow p-4">
        <h2 class="text-lg font-semibold mb-4">Visão Geral do Fluxo de Caixa</h2>
        <CashFlowChart :accounts="accounts" />
      </div>
    </div>
  </div>
</template>